/* eslint-disable max-lines */
import { graphql } from '../../../../gql';

export const GET_ARBEITSZEITEN_BY_DATE_AND_STANDORT_ID = graphql(`
  query getArbeitszeitenByDateAndStandortId(
    $datum: DateTime!
    $standortId: String!
  ) {
    antraegeByStandortId(datum: $datum, standortId: $standortId) {
      __typename
      ... on ArbeitszeitAntraege {
        antraege {
          __typename
          id
          status
          offen
          arbeitszeitId
          bemerkungAntragsteller
          bemerkungVorgesetzter
          datum
          beginn
          ende
          aenderungsdatum
          erstellungsdatum
          arbeitsbereich {
            id
            markierung
            name
          }
          mitarbeiter {
            id
            vorname
            nachname
            bildUrl
            extern
          }
        }
      }
    }
    dienstplanuebernahmen(datum: $datum, standortId: $standortId) {
      arbeitsbereich {
        id
        markierung
        name
      }
      mitarbeiter {
        id
        vorname
        nachname
        bildUrl
        extern
      }
      beginn
      dauer
      ende
      id
      pause
      schichtId
    }
    arbeitszeiten(datum: $datum, standortId: $standortId) {
      ... on ArbeitszeitenByDatum {
        __typename
        datum
        arbeitszeiten {
          __typename
          geaendertVon
          aenderungsdatum
          datum
          ende
          dauer
          id
          konflikte {
            konflikt
            id
          }
          beginn
          kommen
          gehen
          mitarbeiter {
            vorname
            nachname
            bildUrl
            id
            extern
          }
          pauseneinstellung
          pausen {
            id
            art
            ende
            bezahlt
            dauer
            beginn
          }
          dienstgaenge {
            id
            ende
            dauer
            beginn
            art
            bezahlt
          }
          puenktlichkeit {
            abweichungEnde
            abweichungBeginn
          }
          arbeitsbereich {
            __typename
            markierung
            id
            name
            abteilungen {
              __typename
              id
              name
              markierung
            }
          }
          abwesenheit {
            id
            grund
            dauer
          }
          termin {
            beginn
            ende
            beschreibung
            bildName
            bildUrl
            id
            titel
            wiederholung
            markierung
          }
          rechtshinweise {
            __typename
            name
            art
            backgroundcolor
          }
          zuschlaege {
            name
            prozent
            betrag {
              ... on arbeitszeiten_zuschlaege_betrag {
                currency
                betrag
              }
              ... on arbeitszeiten_zuschlaege_noAccess {
                message
              }
            }
            dauer
          }
          antraege {
            id
            beginn
            ende
            aenderungsdatum
            arbeitszeitId
            bemerkungAntragsteller
            bemerkungVorgesetzter
            datum
            erstellungsdatum
            offen
            status
            arbeitsbereich {
              id
              markierung
              name
            }
            mitarbeiter {
              id
              vorname
              nachname
              bildUrl
              extern
            }
          }
          bemerkung
        }
      }
      ... on ArbeitszeitError {
        type
        message
      }
    }
  }
`);

export const GET_ARBEITSBEREICHE_BY_STANDORTID = graphql(`
  query getArbeitsbereicheByStandortId($standortId: String!) {
    arbeitsbereicheByIdStandort(standortId: $standortId) {
      __typename
      ... on ArbeitsbereichByStandortId {
        __typename
        standortId
        arbeitsbereiche {
          __typename
          id
          idStandort
          markierung
          name
          abteilungen {
            id
            name
            markierung
          }
        }
      }
      ... on ArbeitsbereichError {
        type
        message
      }
    }
  }
`);

export const GET_ABTEILUNGEN_BY_STANDORTID = graphql(`
  query getAbteilungenByStandortId($standortId: String!) {
    abteilungenByStandortId(standortId: $standortId) {
      __typename
      ... on AbteilungByStandortId {
        __typename
        standortId
        abteilung {
          id
          markierung
          name
        }
      }
      ... on AbteilungError {
        type
        message
      }
    }
  }
`);
export const GET_TERMINE_BY_DATE_AND_STANDORT_ID = graphql(`
  query getTermineByDateAndStandortId($standortId: String!, $datum: DateTime!) {
    termine(standortId: $standortId, datum: $datum) {
      __typename
      ... on TermineByStandortId {
        standortId
        termine {
          wiederholung
          beginn
          ende
          beschreibung
          titel
          markierung
          id
          bildName
          bildUrl
        }
      }
      ... on TermineError {
        type
        message
      }
    }
  }
`);

export const GET_MITARBEITER_BY_STANDORT_ID = graphql(`
  query getMitarbeiterByStandortId($standortId: String!, $datum: DateTime!) {
    mitarbeiter(standortId: $standortId, date: $datum) {
      ... on MitarbeiterByStandortId {
        standortId
        mitarbeiter {
          id
          vorname
          nachname
          bildUrl
          extern
          arbeitsbereich {
            markierung
            id
            name
          }
        }
      }
      ... on MitarbeiterError {
        message
        type
      }
    }
  }
`);
export const GET_AUDIT_BY_ARBEITSZEIT_ID = graphql(`
  query getAuditByArbeitszeitId($idArbeitszeit: String!) {
    arbeitszeitById(idArbeitszeit: $idArbeitszeit) {
      id
      audit {
        __typename
        ... on Audit {
          __typename
          id
          typ
          aenderungen {
            attribut
            nachher
            vorher
          }
          aenderungsTyp
          aenderungsdatum
          geaendertVon
          geaendertVonEmail
          manager {
            email
            vorname
            nachname
          }
        }
        ... on AuditError {
          __typename
          message
          type
        }
      }
    }
  }
`);

export const GET_ANTRAEGE_BY_STANDORT_ID = graphql(`
  query getAntraegeByStandortId($standortId: String!, $datum: DateTime!) {
    antraegeByStandortId(standortId: $standortId, datum: $datum) {
      __typename
      ... on ArbeitszeitAntraege {
        antraege {
          __typename
          id
          status
          offen
          bemerkungAntragsteller
          bemerkungVorgesetzter
          datum
          arbeitszeitId
          beginn
          ende
          aenderungsdatum
          erstellungsdatum
          arbeitsbereich {
            id
            markierung
            name
          }
          mitarbeiter {
            id
            vorname
            nachname
            bildUrl
            extern
          }
        }
      }
    }
  }
`);

export const GET_ARBEITSZEIT_BY_ID = graphql(`
  query getArbeitszeitById($arbeitszeitId: String!) {
    arbeitszeitById(idArbeitszeit: $arbeitszeitId) {
      __typename
      geaendertVon
      aenderungsdatum
      datum
      ende
      dauer
      beginn
      kommen
      gehen
      id
      beginn2 {
        abweichung
        zeitpunkt
        schicht {
          id
          beginn
          ende
        }
      }
      ende2 {
        abweichung
        zeitpunkt
        schicht {
          id
          beginn
          ende
        }
      }
      kommen2 {
        abweichung
        zeitpunkt
      }
      gehen2 {
        abweichung
        zeitpunkt
      }
      konflikte {
        konflikt
        id
      }
      beginn
      kommen
      gehen
      mitarbeiter {
        vorname
        nachname
        bildUrl
        id
        extern
      }
      pauseneinstellung
      pausen {
        id
        art
        ende
        bezahlt
        dauer
        beginn
      }
      dienstgaenge {
        id
        ende
        dauer
        beginn
        art
        bezahlt
      }
      puenktlichkeit {
        abweichungEnde
        abweichungBeginn
      }
      arbeitsbereich {
        __typename
        markierung
        id
        name
        abteilungen {
          __typename
          id
          name
          markierung
        }
      }
      abwesenheit {
        id
        grund
        dauer
      }
      termin {
        beginn
        ende
        beschreibung
        bildName
        bildUrl
        id
        titel
        wiederholung
        markierung
      }
      rechtshinweise {
        __typename
        name
        art
        backgroundcolor
      }
      zuschlaege {
        name
        prozent
        betrag {
          ... on arbeitszeiten_zuschlaege_betrag {
            currency
            betrag
          }
          ... on arbeitszeiten_zuschlaege_noAccess {
            message
          }
        }
        dauer
      }
      antraege {
        __typename
        id
        status
        offen
        bemerkungAntragsteller
        bemerkungVorgesetzter
        datum
        arbeitszeitId
        beginn
        ende
        aenderungsdatum
        erstellungsdatum
        arbeitsbereich {
          id
          markierung
          name
        }
        mitarbeiter {
          id
          vorname
          nachname
          bildUrl
          extern
        }
      }
      bemerkung
    }
  }
`);

export const GET_TODOS = graphql(`
  query GetToDos($Datum: DateTime!, $standortId: String!) {
    toDos(Datum: $Datum, standortId: $standortId) {
      ... on ToDosAbwesenheiten {
        id
        dauer
        grund
        mitarbeiter {
          id
          vorname
          nachname
          bildUrl
          extern
        }
        arbeitsbereich {
          markierung
          name
          id
          abteilungen {
            id
          }
        }
      }
      ... on ToDosArbeitszeiten {
        id
        beginn {
          zeitpunkt
          abweichung
          schicht {
            id
            beginn
            ende
          }
        }
        ende {
          zeitpunkt
          abweichung
          schicht {
            id
            beginn
            ende
          }
        }
        kommen {
          zeitpunkt
          abweichung
        }
        gehen {
          zeitpunkt
          abweichung
        }
        pausenDauer
        pausen {
          id
          art
          ende
          bezahlt
          dauer
          beginn
        }
        bemerkung
        termin {
          titel
          wiederholung
          id
          bildUrl
          bildName
          beschreibung
          markierung
        }
        mitarbeiter {
          id
          vorname
          nachname
          bildUrl
          extern
        }
        arbeitsbereich {
          markierung
          name
          id
          abteilungen {
            id
          }
        }
        rechtshinweise {
          __typename
          name
          art
          backgroundcolor
        }
        zuschlaege {
          name
          prozent
          betrag {
            ... on arbeitszeiten_zuschlaege_betrag {
              currency
              betrag
            }
            ... on arbeitszeiten_zuschlaege_noAccess {
              message
            }
          }
          dauer
        }
      }
      ... on ToDosKonflikte {
        cause {
          ... on ToDosAbwesenheiten {
            id
            grund
            arbeitsbereich {
              id
              markierung
              name
              abteilungen {
                id
              }
            }
            dauer
            mitarbeiter {
              id
              vorname
              nachname
              bildUrl
              extern
            }
          }
          ... on ToDosArbeitszeiten {
            id
            dauer
            ende {
              zeitpunkt
              abweichung
            }
            beginn {
              zeitpunkt
              abweichung
            }
            kommen {
              zeitpunkt
              abweichung
            }
            gehen {
              zeitpunkt
              abweichung
            }
            bemerkung
            arbeitsbereich {
              markierung
              name
              id
              abteilungen {
                id
              }
            }
            rechtshinweise {
              __typename
              name
              art
              backgroundcolor
            }
            zuschlaege {
              name
              prozent
              betrag {
                ... on arbeitszeiten_zuschlaege_betrag {
                  currency
                  betrag
                }
                ... on arbeitszeiten_zuschlaege_noAccess {
                  message
                }
              }
              dauer
            }
            pausenDauer
            pausen {
              id
              art
              ende
              bezahlt
              dauer
              beginn
            }
            termin {
              titel
              wiederholung
              id
              bildUrl
              bildName
              beschreibung
              markierung
            }

            mitarbeiter {
              id
              vorname
              nachname
              extern
              bildUrl
            }
            arbeitsbereich {
              id
              markierung
              name
            }
          }
        }
        rootArbeitszeit {
          dauer
          id
          ende {
            zeitpunkt
            abweichung
          }
          beginn {
            zeitpunkt
            abweichung
          }
          kommen {
            zeitpunkt
            abweichung
          }
          gehen {
            zeitpunkt
            abweichung
          }
          bemerkung
          arbeitsbereich {
            markierung
            name
            id
            abteilungen {
              id
            }
          }
          rechtshinweise {
            __typename
            name
            art
            backgroundcolor
          }
          zuschlaege {
            name
            prozent
            betrag {
              ... on arbeitszeiten_zuschlaege_betrag {
                currency
                betrag
              }
              ... on arbeitszeiten_zuschlaege_noAccess {
                message
              }
            }
            dauer
          }
          pausenDauer
          pausen {
            id
            art
            ende
            beginn
            bezahlt
            dauer
          }
          termin {
            titel
            wiederholung
            id
            bildUrl
            bildName
            beschreibung
            markierung
          }

          mitarbeiter {
            id
            vorname
            nachname
            bildUrl
            extern
          }
          arbeitsbereich {
            id
            markierung
            name
          }
        }
      }
      ... on ToDoAntraege {
        datum
        antragBeginn: beginn {
          changeRequested
          zeitstempel {
            abweichung
            zeitpunkt
          }
        }
        antragEnde: ende {
          changeRequested
          zeitstempel {
            abweichung
            zeitpunkt
          }
        }
        antragId: id
        mitarbeiter {
          id
          vorname
          nachname
          bildUrl
          extern
        }
        antragArbeitsbereich: arbeitsbereich {
          id
          markierung
          name
          abteilungen {
            id
          }
        }
        status
        offen
        arbeitszeitId
        erstellungsdatum
        aenderungsdatum
        bemerkungAntragsteller
        bemerkungVorgesetzter
      }
    }
  }
`);

export const GET_OPEN_TODOS_FOR_DATEPICKER = graphql(`
  query GetOpenToDosForDatePicker(
    $von: DateTime!
    $bis: DateTime!
    $standortId: String!
  ) {
    findAllToDosForDatepicker(von: $von, bis: $bis, standortId: $standortId) {
      date
      hasOpenToDos
    }
  }
`);

export const GET_IS_MONAT_ABGESCHLOSSEN = graphql(`
  query getIsMonatAbgeschlossen($journaltag: DateTime!) {
    manager {
      ... on Manager {
        id
        idStandort
        standorte {
          id
          name
          settings {
            abteilungenEnabled
          }
          isMonatAbgeschlossen(journaltag: $journaltag)
        }
      }
      ... on ManagerError {
        type
        message
      }
    }
  }
`);
